import React from "react";
import { useTransition, animated, useSpring } from "react-spring";
import { schema, uiSchema } from "wn-claims-shared/dist/schema/geyser-schema";
import Wizard from "../../containers/Wizard";
import { objectMap } from "../../utils/common";
import formData from "./data";

const schemas = [];
const uiSchemas = [];
objectMap(schema.properties, value => {
  schemas.push(value);
  uiSchemas.push(uiSchema);
});

const Geyser = ({ selectFormData }) => {
  const fadeIn = useSpring({ opacity: 1, from: { opacity: 0 } });
  return (
    <animated.div style={fadeIn}>
      <h1>{schema.title}</h1>
      <h5>{schema.description}</h5>
      <Wizard
        schemas={schemas}
        uiSchemas={uiSchemas}
        selectFormData={selectFormData}
        formData={formData}
        readOnly={false}
      />
    </animated.div>
  );
};

export default Geyser;
